import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'file-selector',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatTooltipModule],
  templateUrl: './file-selector.html',
  styleUrl: './file-selector.scss',
})
export class FileSelector 
{
  /** File extension that accepted, same as 'accept' of <input type="file" />.
  By the default, it's set to 'video/*'. */
  @Input() accept = '.mov,.mp4,.mxf,.avi,.gif,.png,.jpg,.jpeg';

  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() fileSelected = new EventEmitter<File[]>();

  @Input() multiple: boolean = false;

  @Input() required: boolean = false;

  @Input() showLabel: boolean = true;

  @Input() label: string = "Select File";

  @Input() fileFormControl!: FormControl;

  @ViewChild('fileSelect') fileSelect !: ElementRef;

  onSelectFile()
  {
    let s: string;

    if(this.fileSelect.nativeElement.files.length > 0) {
      s = this.fileSelect.nativeElement.files[0].name;

      if( this.fileSelect.nativeElement.files.length > 1 ) {
        s = `${s}  (and ${ this.fileSelect.nativeElement.files.length - 1} more)`;
      }

      this.fileFormControl.setValue(this.fileSelect.nativeElement.files[0].name);
      this.fileFormControl.markAsTouched();
      this.fileSelected.emit([...this.fileSelect.nativeElement.files]);
    }
  }

  onClearSelection()
  {
    this.fileFormControl.setValue('');
    this.fileSelect.nativeElement.value = '';
  }

  openFilePicker()
  {
    this.fileSelect.nativeElement.click();
  }
}
